export const SANDBOX_BANNER_HEIGHT = 60;
export const NAVBAR_HEIGHT = 58;
export const SIDEBAR_WIDTH = 220;
export const TRIAL_BANNER_HEIGHT = 60;
